export default "__VITE_ASSET__DcW3w4B___"